import React, { useState } from 'react'
import { Modal, Popover, Button } from 'antd'
import { Initial } from 'react-initial'
import { renderToStaticMarkup } from 'react-dom/server'
import i18n from 'i18n'
import classNames from 'classnames'

import { getEnvParam } from 'env'
import { store as reduxStore } from 'index'

// import store from 'store'
import conf from 'conf'

import {
  getSearchParamProps,
  setSearchParams,
  encodeNSearch,
  // encodeSortMap,
  checkPageReplace,
  timeFormat as timeFormatOrigin,
} from 'utils'

import parse from 'html-react-parser'

import syncAniGIF from 'assets/images/sync-ani.gif'

import sortAscendSVG from 'assets/images/sort-ascend.svg'
import sortDescendSVG from 'assets/images/sort-descend.svg'
import xCircleBlue22SVG from 'assets/images/x-circle-blue-22.svg'
import xCircleRed22SVG from 'assets/images/exclamation-circle-red-22.svg'
import close20SVG from 'assets/images/icon-close-20.svg'
import duplicateIcon from 'assets/images/icon-duplicate.svg'

import styles from './style.module.scss'

export function getHighlightedText(str, highlightText) {
  const txt = str != null ? str : ''
  if (highlightText == null || highlightText.length === 0) {
    return str
  }

  const lowertxt = txt.toLowerCase()
  const lowerHtxt = highlightText.toLowerCase()
  const pos = lowertxt.indexOf(lowerHtxt)

  if (pos >= 0) {
    const preText = txt.substring(0, pos)
    const hText = txt.substring(pos, pos + highlightText.length)
    const nextText = txt.substring(pos + highlightText.length)

    return (
      <span>
        {preText}
        <span className="highlight">{hText}</span>
        {nextText}
      </span>
    )
  }

  return <span>{str}</span>
}

export const colors = [
  '#A9624A',
  '#D06B64',
  '#F83A22',
  '#FA573C',
  '#FF7537',
  '#FF950F',
  '#00BB65',
  '#008247',
  '#43A608',
  '#6BBC00',
  '#FFA600',
  '#FFBC0A',
  '#67AC8F',
  '#61BCC4',
  '#7AA4C8',
  '#4986E7',
  '#6D6FDE',
  '#8562D6',
  '#8D8D8D',
  '#AB8E92',
  '#A7767D',
  '#F46594',
  '#F46594',
  '#7446B7',
]

export function stringToHash(s) {
  let h = 0
  for (let i = 0; i < s.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    h = (Math.imul(31, h) + s.charCodeAt(i)) | 0
  }
  return h
}

export function getInitialAvatar(name, email) {
  if (name == null && email == null) {
    return null
  }

  const avatarProps = {
    // charCount: 2,
    charCount: 1,
  }

  let tmp = []
  if (name != null) {
    tmp = name.split(/[\s\r\n,.]+/gm)
  } else {
    const pos = email.indexOf('@')
    tmp = email.substring(0, pos - 1).split(/[\s\r\n,.]+/gm)
    // const eText = email.substring(pos);
  }

  let str = ''
  tmp.forEach((txt) => {
    if (/^(\p{L}|\d)/gu.test(txt) === true) {
      str += txt.charAt(0)
    }
  })

  str = str.toUpperCase()

  avatarProps.name = str

  // const seed = 0
  // avatarProps.color = colors[Math.floor((str.charCodeAt(0) + seed) % colors.length)]

  const absHash = Math.abs(stringToHash(name || email))
  avatarProps.color = colors[Math.abs(((absHash % colors.length) - 1) % colors.length)]

  return <Initial {...avatarProps} />
}

function unicodeCharAt(str, index) {
  const first = str.charCodeAt(index)
  let second

  if (first >= 0xd800 && first <= 0xdbff && str.length > index + 1) {
    second = str.charCodeAt(index + 1)

    if (second >= 0xdc00 && second <= 0xdfff) {
      return str.substring(index, index + 2)
    }
  }

  return str[index]
}

function unicodeSlice(str, start, end, words) {
  let accumulator = ''
  let character
  let stringIndex = 0
  let unicodeIndex = 0
  let nextSpace = -1
  const { length } = str

  // Remove any leading/trailing spaces
  str = str.trim()

  while (stringIndex < length) {
    character = unicodeCharAt(str, stringIndex)

    if (unicodeIndex >= start && unicodeIndex < end) {
      accumulator += character
    } else {
      break
    }

    stringIndex += character.length
    unicodeIndex += 1

    // Find the next space offset from the previous finding
    nextSpace = words ? str.indexOf(' ', nextSpace + 1) : -1
    stringIndex = nextSpace > 0 ? nextSpace + 1 : stringIndex
  }

  return accumulator
}

export function getInitialAvatarSrcByProps(props) {
  const ownProps = {
    name: 'Name',
    color: null,
    seed: 0,
    charCount: 1,
    textColor: '#ffffff',
    height: 40,
    width: 40,
    fontSize: '20px',
    fontWeight: 700,
    fontFamily:
      'Pretendard GOV Variable, Pretendard GOV, -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif',
    radius: 0,
    ...props,
  }

  const {
    width,
    height,
    textColor,
    fontFamily,
    fontSize,
    fontWeight,
    charCount,
    useWords,
    name,
    color,
    seed,
    radius: borderRadius,
  } = ownProps

  let initial = unicodeSlice(name || 'Name', 0, charCount || 1, useWords || false).toUpperCase()
  let backgroundColor =
    color !== null ? color : colors[Math.floor((initial.charCodeAt(0) + seed) % colors.length)]

  if (name.length === 0) {
    initial = ''
    ;[backgroundColor] = colors
  }

  const InitialSvg = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      pointerEvents="none"
      {...{
        width,
        height,
        style: {
          width,
          height,
          backgroundColor,
          borderRadius,
        },
      }}
    >
      <text
        y="50%"
        x="50%"
        dy="0.35em"
        pointerEvents="auto"
        fill={textColor}
        fontFamily={fontFamily}
        textAnchor="middle"
        style={{ fontSize, fontWeight }}
      >
        {initial}
      </text>
    </svg>
  )

  const encodedStr = encodeURIComponent(renderToStaticMarkup(<InitialSvg />)).replace(
    /%([0-9A-F]{2})/g,
    (match, p1) => {
      return String.fromCharCode(`0x${p1}`)
    },
  )

  const imgStr = window.btoa(encodedStr)
  // const imgStr = window.btoa(unescape(encodeURIComponent(renderToStaticMarkup(<InitialSvg />))));
  const svgHtml = `data:image/svg+xml;base64,${imgStr}`

  return svgHtml
}

export function getInitialAvatarSrc(name, email, props) {
  if (name == null && email == null) {
    return null
  }

  const avatarProps = {
    ...props,
    // charCount: 2,
    charCount: 1,
  }
  if (props == null || props.name == null) {
    if (name == null && email == null) {
      return null
    }

    let tmp = []
    if (name != null) {
      tmp = name.split(/[\s\r\n,.]+/gm)
    } else {
      const pos = email.indexOf('@')
      tmp = email.substring(0, pos - 1).split(/[\s\r\n,.]+/gm)
      // const eText = email.substring(pos);
    }

    let str = ''
    tmp.forEach((txt) => {
      if (/^(\p{L}|\d)/gu.test(txt) === true) {
        str += txt.charAt(0)
      }
    })

    avatarProps.name = str
  }

  const absHash = Math.abs(stringToHash(name || email))
  avatarProps.color = colors[Math.abs(((absHash % colors.length) - 1) % colors.length)]

  return getInitialAvatarSrcByProps(avatarProps)
}

export function getMemberName(member, emailFunc, checkSelf) {
  const myEmail = getEnvParam('userEmail')

  if (member.email === myEmail && checkSelf !== false) {
    return i18n.t('chat.member.myself')
  }

  if (member.display_name == null) {
    if (emailFunc != null) {
      return emailFunc(member.email)
    }
    return member.email
  }

  return member.display_name
}

export function getEmailName(email) {
  const pos = email.indexOf('@')
  return email.substring(0, pos)
}

export function getDefaultName(member, email, checkSelf) {
  if (member != null) {
    return getMemberName(member, getEmailName, checkSelf)
  }

  return getEmailName(email)
}

export function getMemberInfo(member, email, avatarProps, checkSelf) {
  const name = getDefaultName(member, email, checkSelf)

  let avatarSrc = null
  if (member != null) {
    avatarSrc = member.avatar_url
  }

  if (avatarSrc == null || avatarSrc.trim().length === 0) {
    const avatarName = getDefaultName(member, email, false)
    avatarSrc = getInitialAvatarSrc(avatarName, email, avatarProps)
  }

  return {
    name,
    avatarSrc,
  }
}

export function getTotalPeopleElem(count) {
  const totalStr =
    count === 1
      ? i18n.t('common.total.one', { count: `<span class='count'>${count}</span>` })
      : i18n.t('common.total.more', { count: `<span class='count'>${count}</span>` })

  const totalElem = parse(`<span class='total'>${totalStr}</span>`)
  return totalElem
}

export function getTotalUnitElem(count) {
  const totalStr =
    count === 1
      ? i18n.t('common.totalunit.one', { count: `<span class='count'>${count}</span>` })
      : i18n.t('common.totalunit.more', { count: `<span class='count'>${count}</span>` })

  const totalElem = parse(`<span class='total'>${totalStr}</span>`)
  return totalElem
}

export function getTotalAccountElem(count) {
  const totalStr =
    count === 1
      ? i18n.t('common.totalaccount.one', { count: `<span class='count'>${count}</span>` })
      : i18n.t('common.totalaccount.more', { count: `<span class='count'>${count}</span>` })

  const totalElem = parse(`<span class='total'>${totalStr}</span>`)
  return totalElem
}

function PaginationInfo(options) {
  const {
    name,
    offset,
    limit,
    searchItems,
    useSort,
    // defaultSort,
    onPaginationChange,
    paramNames,
    active,
    subtype,
    dateStart,
    dateEnd,
  } = options
  const self = this

  self.name = name
  self.offset = offset
  self.limit = limit
  self.total = 0
  self.active = active
  self.subtype = subtype
  self.dateStart = dateStart
  self.dateEnd = dateEnd
  self.paramNames = {
    valSort: paramNames != null && paramNames.sort != null ? paramNames.sort : 'sort',
    valOrder: paramNames != null && paramNames.order != null ? paramNames.order : 'order',
  }

  const { valSort, valOrder } = self.paramNames

  self.extParams = {}

  self.searchItems = searchItems
  self.searchFilters = {}
  self.sorts = {}

  self.useSort = useSort === true

  self.mount = () => {
    const params = getSearchParamProps()
    console.log(' --- params --- ', params)

    let num = 1

    if (params != null) {
      const { page, nsearch } = params
      if (page != null) {
        num = page
      }

      let extParams = {}
      if (nsearch != null) {
        self.searchFilters = {}
        Object.entries(nsearch).forEach(([key, value]) => {
          self.searchFilters[key] = value
        })

        extParams = {
          ...extParams,
          ...self.searchFilters,
        }
      }

      // if (self.useSort === true) {
      //   self.sorts = {}

      //   if (self.sorts[valSort] == null && defaultSort != null) {
      //     Object.entries(defaultSort).forEach(([key, value]) => {
      //       self.sorts[valSort] = key
      //       self.sorts[valOrder] = value === true ? 'asc' : 'desc'
      //     })
      //   }

      //   extParams = {
      //     ...extParams,
      //     ...self.sorts,
      //   }
      // }

      this.setExtParams(extParams)

      if (self.searchFormObj != null) {
        self.searchFormObj.checkParams()
      }
    }

    self.setPage(num, false, false)
  }

  self.checkParams = () => {
    const params = getSearchParamProps()

    let num = 1

    if (params != null) {
      const { page, nsearch, nsort } = params
      if (page != null) {
        num = page
      }

      let extParams = {}
      if (nsearch != null) {
        self.searchFilters = {}
        Object.entries(nsearch).forEach(([key, value]) => {
          self.searchFilters[key] = value
        })

        extParams = {
          ...extParams,
          ...self.searchFilters,
        }
      }

      if (self.useSort === true && nsort != null) {
        self.sorts = {}
        Object.entries(nsort).forEach(([key, value]) => {
          self.sorts[valSort] = key
          self.sorts[valOrder] = value === true ? 'asc' : 'desc'
        })

        extParams = {
          ...extParams,
          // ...self.sorts,
        }
      }

      this.setExtParams(extParams)
    }

    self.setPage(num, false, false)
  }

  self.setExtParams = (params) => {
    self.extParams = params
  }

  self.getReqParam = () => {
    return {
      offset: self.offset,
      limit: self.limit,
      dateStart: self.dateStart,
      dateEnd: self.dateEnd,
      ...self.extParams,
    }
  }

  self.applyRes = (resPagination) => {
    self.offset = resPagination.offset
    self.limit = resPagination.limit
    self.total = resPagination.total
    self.option = resPagination.option
    self.active = resPagination.active
    self.subtype = resPagination.subtype
    self.dateStart = resPagination.dateStart
    self.dateEnd = resPagination.dateEnd
  }

  self.getPagination = () => {
    const current = Math.floor(self.offset / self.limit) + 1
    const ret = {
      current,
      pageSize: self.limit,
      total: self.total,
      active: self.active,
      subtype: self.subtype,
      dateStart: self.dateStart,
      dateEnd: self.dateEnd,
    }

    if (self.useSort !== true) {
      ret.onChange = (page, pageSize) => {
        self.limit = pageSize
        self.setPage(page, true, true)
      }
    }

    return ret
  }

  self.getOnChange = () => {
    return async (pagination, filters, sorter, extra) => {
      // console.log(' --- filters: ', filters)
      if (self.useSort !== true) {
        return
      }

      let curPage = 1
      if (pagination != null) {
        const { current, pageSize } = pagination
        curPage = current != null ? current : 1
        self.limit = pageSize
      }

      if (extra.action === 'sort') {
        // const { field, order } = sorter
        // console.log('sorter - ', sorter)
        // const sort = {}
        // const sortMap = {}
        // if (order === 'ascend' || order === 'descend') {
        //   ;[sort[valSort]] = field
        //   sort[valOrder] = order === 'ascend' ? 'asc' : 'desc'
        //   sortMap[sort[valOrder]] = order === 'ascend'
        // } else {
        //   delete self.extParams[valSort]
        //   delete self.extParams[valOrder]
        // }
        // const param = {}
        // setSearchParams(param)
        // this.setExtParams({
        //   ...self.extParams,
        // })
      } else {
        self.setPage(curPage, false, true)
      }
    }
  }

  self.getColumns = (columns) => {
    if (self.useSort !== true) {
      return columns
    }

    const newColumns = []
    columns.forEach((col) => {
      const { dataIndex } = col

      const [sort] = dataIndex
      let sortOrder = null
      if (self.extParams[valSort] === sort) {
        sortOrder = self.extParams[valOrder] === 'desc' ? 'descend' : 'ascend'
      }

      const newCol = {
        ...col,
      }

      if (col.sorter !== false) {
        newCol.sorter = true
        newCol.sortOrder = sortOrder
      }

      newColumns.push(newCol)
    })

    return newColumns
  }

  self.setPage = (page, skipRefetch, useSearchParam) => {
    let num = page || 1
    if (typeof page === 'string') {
      try {
        num = parseInt(page, 10)
      } catch {
        num = 1
      }
    }
    self.offset = (num - 1) * self.limit

    if (onPaginationChange != null) {
      if (useSearchParam !== false) {
        const params = {}
        if (page > 1) {
          params[self.name] = page
        } else {
          params[self.name] = undefined
        }

        setSearchParams(params)
      }

      if (skipRefetch !== true) {
        onPaginationChange(page, self.limit, self)
      }
    }
  }

  // for searchForm
  self.getSearchItems = () => {
    return self.searchItems
  }

  // for searchForm
  self.getSearchFilters = () => {
    return self.searchFilters
  }

  self.resetSearch = (/* skipRefetch, extItem */) => {
    Object.keys(self.searchFilters).forEach((key) => {
      if (self.extParams[key] != null) {
        delete self.extParams[key]
      }
    })
    self.searchFilters = {}
  }

  self.checkPageReplace = (props, prevProps) => {
    if (props.location != null && prevProps.location != null) {
      if (checkPageReplace(props.location, prevProps.location) === false) {
        console.log(' ----  checkPageReplace ', props, prevProps)

        self.checkParams()
      }
    }
  }

  // for searchForm
  self.search = (key, value, preset, skipRefetch, useSearchParam) => {
    console.log('search - ', key, value, preset, skipRefetch, useSearchParam)

    self.searchFilters = {}

    const params = {
      nsearch: undefined,
    }

    if (value != null) {
      self.searchFilters[key] = undefined

      if (value.trim().length > 0) {
        self.searchFilters[key] = value
        params.nsearch = encodeURIComponent(encodeNSearch(self.searchFilters))
      }
    }

    const extParams = {
      ...self.extParams,
      ...self.searchFilters,
    }

    self.setExtParams(extParams)

    if (useSearchParam === true) {
      setSearchParams(params)
    }

    console.log('onSearch2 - ', key, value)

    // if (skipRefetch !== true) {
    self.setPage(1, skipRefetch, useSearchParam)
    // }

    return true
  }
}

export function createPaginationInfo(offset, limit, onPaginationChange) {
  return new PaginationInfo(offset, limit, onPaginationChange)
}

export function sortIconFunc({ sortOrder }) {
  if (sortOrder === 'ascend' || sortOrder === 'descend') {
    const icon =
      sortOrder === 'ascend' ? (
        <img src={sortAscendSVG} alt="ascend" />
      ) : (
        <img src={sortDescendSVG} alt="descend" />
      )
    return icon
  }

  return null
}

export function timeFormat(timeStr, formatStr) {
  const format = formatStr || 'YYYY.MM.DD HH:mm'
  return timeFormatOrigin(timeStr, format)
}

export function confirmBase(options) {
  const opts = {
    title: options.title,
    icon: null,
    closeIcon: <img src={close20SVG} alt="close" />,
    closable: options.closable,
    width: options.width,
    content: options.content,
    maskTransitionName: 'maskTransitionName',
    okButtonProps: {
      className: classNames('type6', 'h38'),
      style: { minWidth: '100px' },
    },
    cancelButtonProps: {
      className: classNames('h38'),
      style: { minWidth: '100px' },
    },
    open: options.open,
    onOk: options.onOk,
    onCancel: options.onCancel,
    footer: options.footer,
    ...options,
    // 속성을 변경하여 덮어씌우는 경우에는 아래에서 처리.
    wrapClassName: classNames('om-popup-1', options.wrapClassName),
    keyboard: options.maskClosable != null ? options.maskClosable : true,
    maskClosable: options.maskClosable != null ? options.maskClosable : true,
    style: { minWidth: '380px', ...options.style },
    okText: options.okText || i18n.t('common.button.ok'),
    cancelText: options.cancelText || i18n.t('common.button.cancel'),
  }

  if (options.hasIcon === true) {
    opts.icon = <img src={xCircleBlue22SVG} alt="noti" />
  }

  if (options.icon !== undefined) {
    opts.icon = options.icon
  }

  return Modal.confirm(opts)
}

export function errorBase(options) {
  const opts = {
    wrapClassName: options.wrapClassName || classNames('om-popup-error-1'),
    title: options.title,
    closable: options.closable,
    keyboard: options.maskClosable != null ? options.maskClosable : true,
    maskClosable: options.maskClosable != null ? options.maskClosable : true,
    style: { minWidth: '380px' },
    width: options.width,
    content: options.content,
    okText: options.okText || i18n.t('common.button.ok'),
    okButtonProps: options.okButtonProps || { className: classNames('h38', 'type1', 'w100') },
    maskTransitionName: 'maskTransitionName',
    onOk: options.onOk,
    footer: options.footer,
    onCancel: options.onCancel,
    cancelText: options.cancelText || i18n.t('common.button.cancel'),
    ...options,
  }

  if (options.icon !== undefined) {
    opts.icon = options.icon
  } else {
    opts.icon = <img src={xCircleRed22SVG} alt="error" />
  }

  return Modal.error(opts)
}

export function confirmDelete(options) {
  return confirmBase({
    maskTransitionName: 'maskTransitionName',
    okText: i18n.t('common.button.delete'),
    width: 480,
    okButtonProps: {
      className: classNames('type5', 'h38'),
      style: { minWidth: '100px' },
    },
    cancelButtonProps: {
      className: classNames('h38'),
      style: { minWidth: '100px' },
    },
    ...options,
  })
}

export function confirmDiscard({ title, content, submit }) {
  return confirmDelete({
    icon: <img src={xCircleRed22SVG} alt="xCircleRed22SVG" />,
    title,
    content,
    okText: i18n.t('common.button.ok'),
    onOk: submit,
  })
}

export function mailApiError(ex) {
  const e = ex.origin != null ? ex.origin : ex
  if (e.message != null) {
    const { code, message, details, desc } = e
    const title = code != null ? `${message} (${code})` : message
    let content = ''
    if (details != null && details.reason != null) {
      content = details.reason
    } else if (desc != null) {
      content = details.desc
    }
    errorBase({
      title,
      content,
      width: 450,
    })
  } else {
    errorBase({
      title: 'Unknown error',
      content: JSON.stringify(e),
      width: 450,
    })
  }
}

export function popupDoc(options) {
  return confirmBase({
    wrapClassName: classNames(styles.docPopup),
    maskTransitionName: 'maskTransitionName',
    closable: true,
    footer: null,
    width: 896,
    ...options,
  })
}

export function openPrivacy(e) {
  const { language } = i18n

  const SRC = {
    'ko-KR': '/static/Safebox_privacy_policy_kor.html',
    'en-US': '/static/Safebox_privacy_policy_eng.html',
    'ja-JP': '/static/Safebox_privacy_policy_jpn.html',
  }
  popupDoc({
    title: i18n.t('appConfig.label.privacyPolicy'),
    content: (
      <div className={classNames(styles.docScroll)}>
        <iframe
          id="contentFrame"
          title="OfficeMail Privacy Policy"
          src={SRC[language]}
          marginWidth="0"
          marginHeight="0"
          frameBorder="0"
          width="100%"
          height="100%"
          scrolling="yes"
        />
      </div>
    ),
  })

  if (e != null) {
    e.stopPropagation()
    e.preventDefault()
  }
}

export function openTerms(e) {
  const { language } = i18n

  const SRC = {
    'ko-KR': '/static/Safebox_terms_use_kor_20250206.htm?code=1',
    'en-US': '/static/Safebox_terms_use_eng_20250206.html',
    'ja-JP': '/static/Safebox_terms_use_jpn_20250206.html',
  }

  popupDoc({
    title: i18n.t('appConfig.label.termsOfService'),
    content: (
      <div className={classNames(styles.docScroll)}>
        <iframe
          id="contentFrame"
          title="Safebox Terms of Service"
          src={SRC[language]}
          width="100%"
          height="100%"
        />
      </div>
    ),
  })

  if (e != null) {
    e.stopPropagation()
    e.preventDefault()
  }
}

export function logout() {
  reduxStore.dispatch({
    type: 'user/LOGOUT',
  })
}

export function getOfficeNEXTURL(path) {
  const { officeNextURL } = conf

  if (officeNextURL != null && officeNextURL.length > 0) {
    const lang = i18n.language.substring(0, 2)
    const pathStr = path || '/'
    return `${officeNextURL}/${lang}${pathStr}`
  }

  return null
}

export function getTechSupportElem() {
  return (
    <div>
      {i18n.t('onboarding.selectDomain.techSupport')} | 1661-5975, &nbsp;
      <a href="mailto:officetech@jiran.com" target="_blank" rel="noreferrer">
        officetech@jiran.com
      </a>
    </div>
  )
}

export const getCopyFunc = ({ name, value, copyRef }) => {
  const handleCopy = () => {
    let copyText = copyRef ? copyRef.current.getFieldValue(name) : value
    if (copyText == null) {
      copyText = ''
    }

    navigator.clipboard.writeText(copyText)
  }

  return handleCopy
}

export const CopyPopoverComponent = ({ name, value, copyRef, funcMap, initValue }) => {
  const [copy, setCopy] = useState(false)
  const [btnCls, setBtnCls] = useState(initValue != null && initValue.length > 0 ? '' : 'empty')

  if (funcMap != null && name != null) {
    funcMap[name] = {
      setBtnCls,
      getBtnCls: () => btnCls,
    }
  }

  const handleCopy = () => {
    let copyText = copyRef ? copyRef.current.getFieldValue(name) : value
    if (copyText == null) {
      copyText = ''
    }

    if (navigator.clipboard.writeText(copyText)) {
      setCopy(true)
      setTimeout(() => setCopy(false), 2000)
    }
  }

  const PopoverContent = () => (
    <Popover
      placement="topRight"
      content={`${i18n.t('workspace.result.copySuccess')}`}
      trigger={copy ? 'hover' : null}
      open={copy}
      onClick={handleCopy}
    >
      <Button
        tabIndex={-1}
        className={classNames('copyPopover', btnCls)}
        type="text"
        icon={<img src={duplicateIcon} alt="duplicate" />}
      />
    </Popover>
  )

  return copyRef ? copyRef.current && <PopoverContent /> : <PopoverContent />
}

export const passwordStrength = ({ value, strength }) => {
  const calculate = () => {
    let score = 0
    if (value.length >= 12) score += 2
    else if (value.length >= 8) score += 1

    if (/[a-z]/.test(value)) score += 1

    if (/[A-Z]/.test(value)) score += 1

    if (/[0-9]/.test(value)) score += 1

    if (/[\!@#\$%\^&\*\(\)_\+\~\`\|\₩\"\}\{\[\]:;\'<>,\.\?\\/=\-]/.test(value)) score += 1

    // 연속 문자나 반복 문자 감지 (3번이면 보안 감소)
    if (/([a-zA-Z0-9])\1\1/.test(value)) score -= 1

    // 점수 클램핑 (최소 0, 최대 5)
    score = Math.max(0, Math.min(5, score))

    return score
  }

  const COLOR_LABELS = {
    RED: '#FD4C45',
    ORANGE: '#FF9045',
    GREEN: '#10BF79',
  }

  const strengthData = {
    0: { label: 0, text: i18n.t('record.passwordStrength.veryWeak'), color: COLOR_LABELS.RED },
    1: { label: 20, text: i18n.t('record.passwordStrength.weak'), color: COLOR_LABELS.RED },
    2: { label: 40, text: i18n.t('record.passwordStrength.fair'), color: COLOR_LABELS.ORANGE },
    3: { label: 60, text: i18n.t('record.passwordStrength.strong'), color: COLOR_LABELS.ORANGE },
    4: { label: 80, text: i18n.t('record.passwordStrength.veryStrong'), color: COLOR_LABELS.GREEN },
    5: {
      label: 100,
      text: i18n.t('record.passwordStrength.veryStrong'),
      color: COLOR_LABELS.GREEN,
    },
  }

  return {
    labels: strengthData[strength]?.label || 0,
    text: strengthData[strength]?.text || '',
    color: strengthData[strength]?.color || '#FFFFFF',
    calculate,
  }
}

export function openloadingAni(options) {
  const opts = {
    wrapClassName: classNames('loading-ani-popup'),
    maskTransitionName: 'maskTransitionName',
    icon: null,
    width: 384,
    title: null,
    footer: null,
    content: (
      <div className={classNames('loading-content')}>
        <div className={classNames('loading-ani')}>
          <img src={syncAniGIF} alt="sync" />
        </div>
        <div className={classNames('loading-text')}>{options.text}</div>
      </div>
    ),
  }

  return Modal.confirm(opts)
}

export const errorTranslationMessage = (errorCode, translate, messageApi) => {
  const error = translate(`workspace.error.${errorCode}`)
  return messageApi.open({
    type: 'error',
    content: error,
  })
}

const uiUtil = {
  getInitialAvatar,
  getInitialAvatarSrcByProps,
  getInitialAvatarSrc,
  getTotalPeopleElem,
  getTotalUnitElem,
  getEmailName,
  createPaginationInfo,
  sortIconFunc,
  timeFormat,
  confirmDelete,
  openPrivacy,
  openTerms,
  getOfficeNEXTURL,
  // logoutOfficeNEXT,
  getTechSupportElem,
  errorTranslationMessage,
}

export default uiUtil
